var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPerson16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 14.6C11.6451 14.6 14.6 11.6451 14.6 8.00002C14.6 4.35494 11.6451 1.40002 7.99999 1.40002C4.35491 1.40002 1.39999 4.35494 1.39999 8.00002C1.39999 11.6451 4.35491 14.6 7.99999 14.6Z",
    fill: "#F4F4F4",
    stroke: "#F4F4F4",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 4.34103C8.98842 4.34103 9.78973 5.14234 9.78973 6.1308C9.78973 7.11927 8.98842 7.92058 7.99996 7.92058C7.01149 7.92058 6.21018 7.11927 6.21018 6.1308C6.21018 5.14234 7.01149 4.34103 7.99996 4.34103ZM7.99996 3.62512C6.61611 3.62512 5.49427 4.74695 5.49427 6.1308C5.49427 7.51465 6.61611 8.63649 7.99996 8.63649C9.38381 8.63649 10.5056 7.51465 10.5056 6.1308C10.5056 4.74695 9.38381 3.62512 7.99996 3.62512ZM11.5795 13.6478H10.8636V11.8581C10.8636 11.3834 10.675 10.9282 10.3394 10.5925C10.0037 10.2569 9.5485 10.0683 9.07382 10.0683H6.92609C5.93763 10.0683 5.13632 10.8696 5.13632 11.8581V13.6478H4.42041V11.8581C4.42041 10.4742 5.54224 9.3524 6.92609 9.3524H9.07382C10.4577 9.3524 11.5795 10.4742 11.5795 11.8581V13.6478Z",
    fill: "#CACACA"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPerson16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person-16.8992520993bf10c8a593c6e9547dd54d.svg";